// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-786c9d4f] .v-list-item{max-height:100px!important;min-height:65px!important}[data-v-786c9d4f] .v-list-item--link:before{background:none}", ""]);
// Exports
module.exports = exports;
